import * as React from 'react';
import styled from 'styled-components';
import SelectIcon from '../Icons/SelectIcon';
import { useTabsDispatch, useTabsState } from './TabsContext';
import Heading from '@ids/components/Typography/Heading';
import { usePriceTiersBlock } from '@ids/context';
import { Price } from '@ids/pages/landing/blocks/PriceTiers/Price';

const StyledMostPopularLabel = styled.div`
    background: ${({ theme }) => theme.colors.turquoise100};
    color: ${({ theme }) => theme.colors.white};
    font-size: 8px;
    padding: 3px 4px;
    position: absolute;
    left: 3px;
    bottom: 100%;
    line-height: 1;
`;

const MostPopularLabel = () => {
    const mostPopularText = usePriceTiersBlock()?.mostPopularText ?? 'Most Popular';

    return <StyledMostPopularLabel>{mostPopularText}</StyledMostPopularLabel>;
};

const StyledTabList = styled.ul`
    display: grid;
    grid-gap: 10px;
    grid-template-columns: repeat(auto-fit, minmax(90px, 1fr));
`;

export const StyledTab = styled.li`
    display: flex;
    position: relative;
    flex-direction: column;
    padding: 10px 10px 20px 10px;
    color: ${({ theme }) => theme.colors.charcoal100};
    background: ${({ theme }) => theme.colors.charcoal20New};

    &[data-selected='true'] {
        background: ${({ theme }) => theme.colors.white};
    }
`;

const StyledSelectIcon = styled(SelectIcon)`
    position: absolute;
    top: 5px;
    right: 5px;
`;

const StyledTitle = styled(Heading).attrs({ as: 'h3' })`
    margin-bottom: 0;
`;

const TabList = () => {
    const tabs = useTabsState();
    const { selectTab } = useTabsDispatch();

    return (
        <StyledTabList role="tablist" aria-orientation="horizontal">
            {tabs.map((tier, idx) => (
                <StyledTab
                    role="tab"
                    id={`tab-${idx}`}
                    key={tier.title}
                    onClick={() => selectTab(idx)}
                    aria-selected={tier.isSelected}
                    data-selected={tier.isSelected}
                >
                    {tier.mostPopular && <MostPopularLabel />}
                    <StyledTitle>{tier.title}</StyledTitle>
                    <StyledSelectIcon />
                    <Price priceTier={tier} />
                </StyledTab>
            ))}
        </StyledTabList>
    );
};
export default TabList;
